import React, {useState} from 'react';
import {Text, TouchableOpacity} from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {styles} from './styles';
import {Colors} from '../../constants/Colors';

interface ICheckBox {
  description: string;
  mt?: number;
  alignSelf?: string;
  isCheck: boolean;
  onPress: () => void;
}

const CheckBox = ({
  description,
  mt,
  alignSelf = 'center',
  isCheck,
  onPress,
}: ICheckBox) => {
  const [check, setCheck] = useState<boolean>(false);

  return (
    <TouchableOpacity
      style={{...styles.container, marginTop: mt, alignSelf: alignSelf}}
      onPress={onPress}>
      {isCheck ? (
        <MaterialCommunityIcons
          name="checkbox-marked"
          size={20}
          color={Colors.GrayPallete.lightgrayThree}
        />
      ) : (
        <MaterialCommunityIcons
          name="checkbox-blank-outline"
          size={20}
          color={Colors.GrayPallete.lightgrayThree}
        />
      )}
      <Text style={styles.text}>{description}</Text>
    </TouchableOpacity>
  );
};

export default CheckBox;
